<script setup>
const { locale } = useI18n()

const nuxtApp = useNuxtApp()

nuxtApp.hook("page:finish", () => {
		window.scrollTo(0, 0)
})

useHead({
	htmlAttrs: {
    lang: locale.value
  }
})
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>

	<div class="sr-only" aria-hidden="false">
    <p v-if="locale === 'cs'">
      SUPRAPHON a.s. si podle § 39c odst. 2 autorského zákona č. 121/2000 Sb.
      výslovně vyhrazuje práva ke všem svým chráněným dílům (zejména textům,
      hudebním dílům, zvukovým a zvukově obrazovým záznamů, grafickým a výtvarným
      dílům) včetně jejich rozmnoženin a derivátů proti jejich užití pro účely
      automatizované analýzy textů nebo dat v digitální podobě (TDM - text and data mining).
    </p>

    <p v-else>
      SUPRAPHON a.s. hereby expressly reserves, pursuant to Section 39c(2) of Act No. 121/2000 Coll.,
      the Copyright Act (implementing Article 4(3) of Directive (EU) 2019/790), all rights in respect
      of all its protected works, in particular literary works, musical works, sound recordings,
      audiovisual recordings, graphic works and works of fine art, including any reproductions and
      derivative works thereof, against their use for the purposes of automated text and data mining
      in digital form (TDM – text and data mining).
    </p>
  </div>
</template>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.2s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(1rem);
}
</style>